import {PercentileText} from '@/componentLibrary/blocks/testReports/components/PercentileText';

export function LogicPercentile({standardScore}: {standardScore: number}) {
    return <PercentileText standardScore={standardScore} />;
}
